import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { Card, CardContent } from "@/components/ui/card";

export function PrivacyPage() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-2xl">
      <PageHeader title={t("pages.privacyTitle")} />
      <Card>
        <CardContent className="pt-6">
          <p>{t("pages.privacyBody")}</p>
        </CardContent>
      </Card>
    </div>
  );
}

export function TermsPage() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-2xl">
      <PageHeader title={t("pages.termsTitle")} />
      <Card>
        <CardContent className="pt-6">
          <p>{t("pages.termsBody")}</p>
        </CardContent>
      </Card>
    </div>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-2xl text-center">
      <PageHeader title={t("pages.notFoundTitle")} description={t("pages.notFoundBody")} />
      <Link to="/">{t("common.nav.home")}</Link>
    </div>
  );
}
